import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useMutation, useQueryClient } from 'react-query';
import { CerebroTextButton } from '../../shared/components';
import { useApi } from '../../shared/context';
import { QueryKeys } from '../../shared/hooks';
import { DataRoomFolder } from '../../shared/models';
import { CerebroApiEndpoints } from '../../shared/utils/api';
import { getResponseData } from '../../shared/utils/axios';

interface RemoveFolderDialogProps {
	dataRoomGuid: string | undefined;
	folder: DataRoomFolder | null;
	close: () => void;
}

export const RemoveFolderDialog: React.FC<RemoveFolderDialogProps> = ({ dataRoomGuid, folder, close }) => {
	const api = useApi();
	const snackbar = useSnackbar();
	const client = useQueryClient();

	const onRemoveConfirmation = () => {
		if (folder !== null) removeFolder(folder);
	};

	const { mutate: removeFolder } = useMutation<DataRoomFolder, unknown, DataRoomFolder>(
		folderToDelete =>
			getResponseData(
				api.delete<DataRoomFolder>(CerebroApiEndpoints.Documents.Folder(dataRoomGuid, folderToDelete.guid))
			),
		{
			onMutate: () => {
				close();
			},
			onSuccess: (_data, deletedFolder) => {
				client.invalidateQueries(QueryKeys.Documents.Root(dataRoomGuid, folder?.guid));
				snackbar.enqueueSnackbar('Folder Deleted.', { variant: 'success' });

				close();
			},
			onError: () => {
				client.invalidateQueries(QueryKeys.Teasers.Root(dataRoomGuid));
				snackbar.enqueueSnackbar('There was a problem deleting the folder.', { variant: 'error' });
			},
		}
	);

	return (
		<Dialog open={folder !== null} onClose={close}>
			<DialogTitle>Confirm Delete</DialogTitle>
			<DialogContent>
				<DialogContentText>Are you sure you want to delete this folder: {folder?.name}?</DialogContentText>
			</DialogContent>
			<DialogActions>
				<CerebroTextButton onClick={close}>No</CerebroTextButton>
				<CerebroTextButton onClick={onRemoveConfirmation}>Yes</CerebroTextButton>
			</DialogActions>
		</Dialog>
	);
};
